// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"fab9c500","219":"1b9cf5b6","278":"0631e726","761":"031fbfcc","963":"cdb222af"}[chunkId] + ".css";
};